import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate, fmtMoney, PROJECT_STATUS, MILESTONES } from "@/lib/constants";

const box = { border: "1px solid #ccc", borderRadius: 8, padding: "12px 16px" };
const lbl = { fontSize: 10, textTransform: "uppercase", letterSpacing: 1, color: "#666" };

export default function PrintProject() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    Promise.all([api.get(`/projects/${id}`), api.get(`/projects/${id}/documents`)])
      .then(([a, b]) => { setP(a.data); setDocs(b.data); setTimeout(() => window.print(), 800); })
      .catch(() => {});
  }, [id]);

  if (!p) return <div style={{ padding: 40, fontFamily: "Arial" }}>Se încarcă…</div>;
  const mi = MILESTONES.find((m) => m.code === p.current_milestone);

  return (
    <div className="printable" style={{ background: "#fff", color: "#111", fontFamily: "Arial, sans-serif", padding: 40, maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid #111", paddingBottom: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#3B82F6" }}>HIGHBERG</div>
          <div style={{ fontSize: 11, color: "#666" }}>HGS-OPEP · Fișă Unică de Proiect</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: "monospace", fontWeight: 700 }}>{p.code}</div>
          <div style={{ fontSize: 12, color: "#666" }}>{fmtDate(new Date().toISOString())}</div>
        </div>
      </div>

      <h1 style={{ fontSize: 22, margin: "16px 0" }}>{p.name}</h1>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
        <div style={box}><div style={lbl}>Client</div><div>{p.client || "—"}</div></div>
        <div style={box}><div style={lbl}>Beneficiar</div><div>{p.beneficiary || "—"}</div></div>
        <div style={box}><div style={lbl}>Țară / Șantier</div><div>{p.country} {p.site_address}</div></div>
        <div style={box}><div style={lbl}>Produs</div><div>{p.product_type || "—"}</div></div>
        <div style={box}><div style={lbl}>Contract</div><div>{p.contract_ref || "—"}</div></div>
        <div style={box}><div style={lbl}>Status</div><div>{PROJECT_STATUS[p.status]} · {p.current_milestone} {mi?.label}</div></div>
        <div style={box}><div style={lbl}>Termen contractual</div><div>{fmtDate(p.contract_deadline)}</div></div>
        <div style={box}><div style={lbl}>Buget</div><div>{fmtMoney(p.budget)}</div></div>
        <div style={box}><div style={lbl}>Costuri</div><div>{fmtMoney(p.costs)}</div></div>
      </div>

      <h3 style={{ fontSize: 14, borderBottom: "1px solid #ccc", paddingBottom: 6 }}>Cerințe tehnice</h3>
      <p style={{ fontSize: 13 }}>
        Dimensiuni: {p.tech?.dimensions || "—"} · Capacitate: {p.tech?.capacity || "—"} · Materiale: {p.tech?.materials || "—"} · Standarde: {p.tech?.standards || "—"}
      </p>

      <h3 style={{ fontSize: 14, borderBottom: "1px solid #ccc", paddingBottom: 6, marginTop: 16 }}>Documente ({docs.length})</h3>
      <ul style={{ fontSize: 13 }}>
        {docs.map((d) => <li key={d.id}>{d.number} — {d.title} ({d.total_with_vat} lei)</li>)}
        {docs.length === 0 && <li>—</li>}
      </ul>

      <div style={{ marginTop: 40, fontSize: 11, color: "#999", textAlign: "center" }}>
        Generat din HGS-OPEP · Highberg Solution
      </div>
    </div>
  );
}
